import { useRef } from 'react';
import { useDialog } from '../lib/useDialog';

/** "2 hours", "90 minutes", "1 hour" -- how the limit reads in a sentence. */
export const idleLimitLabel = (minutes: number) =>
  minutes % 60 === 0
    ? `${minutes / 60} hour${minutes === 60 ? '' : 's'}`
    : `${minutes} minute${minutes === 1 ? '' : 's'}`;

/**
 * The minute before an idle console signs out (auth/idle.ts). Any key, click
 * or movement closes it as well as the button does -- it is there for the
 * person who has just come back, not to make them prove it twice. Escape is
 * staying, never signing out.
 */
export function IdleWarning({
  leftMs,
  limitMinutes,
  onStay,
  onSignOut,
}: {
  leftMs: number;
  limitMinutes: number;
  onStay: () => void;
  onSignOut: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useDialog(ref, onStay);
  const seconds = Math.max(0, Math.ceil(leftMs / 1000));

  return (
    <div className="dialog-backdrop">
      <div
        ref={ref}
        className="dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="idle-title"
        aria-describedby="idle-body"
      >
        <h2 id="idle-title">Still there?</h2>
        <div className="dialog-body" id="idle-body">
          <p style={{ margin: 0 }}>
            The console signs out after {idleLimitLabel(limitMinutes)} without use. You will be signed out in{' '}
            <strong>
              {seconds} second{seconds === 1 ? '' : 's'}
            </strong>
            .
          </p>
        </div>
        <div className="dialog-actions">
          <button type="button" className="btn btn-secondary" onClick={onSignOut}>
            Sign out now
          </button>
          <button type="button" className="btn btn-primary" onClick={onStay}>
            Stay signed in
          </button>
        </div>
      </div>
    </div>
  );
}
